import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from '../redux/store'
import OverlayLoaderProvider from './OverlayLoader/OverlayLoaderProvider'
import Router from './Router'
import ToastProvider from './toast/ToastProvider'

const App = () => {
    return <Provider store={store}>
        <PersistGate persistor={persistor}>
            <ToastProvider>
                <OverlayLoaderProvider>
                    <Router />
                </OverlayLoaderProvider>
            </ToastProvider>
        </PersistGate>
    </Provider>
}

export default App
